<template>
  <div>
    <title>基本信息</title>
    <!--S 公用头部切换-->
    <GoodsInfoTab :active="currentTit"></GoodsInfoTab>
    <!--E 公用头部切换-->
    <!-- S 基础详情表单组件 -->
    <GoodsInfoPage :goodsType="0"></GoodsInfoPage>
    <!-- E 基础详情表单组件 -->
    
  </div>
</template>
<script>

export default {
  name: 'goodsBasicInfo',
  data () {
    return {
      currentTit:0, //当前选中菜单
    }
  },
  filters: {

  },
  components: {
    GoodsInfoTab: resolve => require(["@/components/GoodsFolder/GoodsInfoTab.vue"],resolve), //头部tab组件
    GoodsInfoPage: resolve => require(["@/components/common/GoodsInfoPage.vue"],resolve), // 基础详情表组件
  },
  methods: {
    
  },
  created() {
    
  },
  mounted(){
        // //在dom渲染之后
        // setTimeout(()=>{
        //   //暂时只加了实物商品部分的修改图片顺序图标，如果好实现，其他地方同步，不好实现则删除不要
        //   document.querySelectorAll(".el-upload-list__item-name")[0].innerHTML = '<i class="el-icon-back" ></i><i class="el-icon-right"></i>'
        //   document.querySelectorAll(".el-upload-list__item-name")[0].className="operateCover";
        // },1000)
    },
  computed: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/GoodsCommodity/GoodsBasicInfo.vue